export enum CONTENT_TYPES {
    DEVICE = 'devices',
    DEVICESET = 'device_sets',
};

export type ChartSamplingFilter = {
    key: string,
    label: string,
    zoom: string,
    delta: number,
};

export type ChartSamplingTypeFilter = {
    key: string,
    label: string,
};

export const CHART_SAMPLING_TYPE_OPTIONS: ChartSamplingTypeFilter[] = [
    {
        key: 'avg',
        label: 'Media',
    },
    {
        key: 'min',
        label: 'Minimo',
    },
    {
        key: 'max',
        label: 'Massimo',
    },
];

export const CHART_SAMPLING_OPTIONS: ChartSamplingFilter[] = [
    {
        key: '5min',
        label: '5 minuti',
        zoom: 'raw',
        delta: 300,
    },
    {
        key: '10min',
        label: '10 minuti',
        zoom: 'raw',
        delta: 600,
    },
    {
        key: '15min',
        label: '15 minuti',
        zoom: 'raw',
        delta: 900,
    },
    {
        key: '30min',
        label: '30 minuti',
        zoom: 'raw',
        delta: 1800,
    },
    {
        key: '1hour',
        label: '1 ora',
        zoom: '2min',
        delta: 3600,
    },
    {
        key: '3hour',
        label: '3 ore',
        zoom: '2min',
        delta: 10800,
    },
    {
        key: '6hour',
        label: '6 ore',
        zoom: '2min',
        delta: 21600,
    },
    {
        key: '12hour',
        label: '12 ore',
        zoom: '2min',
        delta: 43200,
    },
    {
        key: '1day',
        label: '1 giorno',
        zoom: '24min',
        delta: 86400,
    },
    {
        key: '3day',
        label: '3 giorni',
        zoom: '24min',
        delta: 259200,
    },
    {
        key: '5day',
        label: '5 giorni',
        zoom: '24min',
        delta: 432000,
    },
    {
        key: '1week',
        label: '1 settimana',
        zoom: '2hour',
        delta: 604800,
    },
    {
        key: '2week',
        label: '2 settimane',
        zoom: '2hour',
        delta: 1209600,
    },
    {
        key: '3week',
        label: '3 settimane',
        zoom: '2hour',
        delta: 1814400,
    },
    {
        key: '1month',
        label: '1 mese',
        zoom: '24hour',
        delta: 2592000,
    },
    {
        key: '2month',
        label: '2 mesi',
        zoom: '24hour',
        delta: 5184000,
    },
    {
        key: '3month',
        label: '3 mesi',
        zoom: '24hour',
        delta: 7776000,
    },
    {
        key: '4month',
        label: '4 mesi',
        zoom: '24hour',
        delta: 10368000,
    },
    {
        key: '5month',
        label: '5 mesi',
        zoom: '24hour',
        delta: 12960000,
    },
    {
        key: '6month',
        label: '6 mesi',
        zoom: '24hour',
        delta: 15552000,
    },
    {
        key: '12month',
        label: '12 mesi',
        zoom: '24hour',
        delta: 31104000,
    },
];